import { AppStorage } from './storage'
import { DayInterface, HomeDayItemInterface, MealInterface, HomeMealItemInterface, FlattenedLists, RandomisedObjectInterface, PolyDialogTypeInterface, DayMealItemExactIndiceInterface, HomeHistoryItemInterface, StateObjectInterface } from '@/interfaces';

import moment from 'moment'
import * as axiosData from 'axios'
import uuid from 'uuid'
import { RandomisedListsInterface, Randomise } from '@/logic';

const axios = axiosData.default

export class DataProvider {
    private token: string = ''

    private serverUrl: string = 'https://foorize-server.herokuapp.com'
    // private serverUrl: string = 'http://localhost:3000'

    private storageKey: string = "state"

    private _2WeekCreationDate: string = ''

    private timetablesArray: Array<Array<DayInterface>> = []

    private _5DayDataArray: Array<HomeDayItemInterface> = []

    private historyItems: Array<HomeHistoryItemInterface> = []

    private namedTimetablesArray: Array<HomeHistoryItemInterface> = []

    private currentlyActiveNamedTimetable: HomeHistoryItemInterface | undefined

    private currentlyLoggedInEmail: string = ''

    constructor(private storage: AppStorage) { }

    public async init(): Promise<void> {
        try {
            await this.deserializeAndUnwrapState()

        } catch (e) {
            throw (e)
        }
    }

    async checkIfStateIsStored(): Promise<boolean> {
        try {
            const serializedState = await this.storage.get(this.storageKey)

            //
            return typeof serializedState === 'string'

        } catch (e) {
            return false
        }
    }

    private getFirstOrSecondWeekStatus(startDateISOString: string, currentISOStringDate: string): boolean {

        const daysDifference: number = moment(currentISOStringDate).diff(moment(startDateISOString), 'days')
        const weekDivisor: number = Math.ceil(daysDifference / 7)
        const isFirstWeek: boolean = weekDivisor % 2 !== 0

        return isFirstWeek
    }

    private getDayItem(realDayISODate: string, dayDate: string, dayData: DayInterface, dayIndex: number): HomeDayItemInterface {
        const date: number = Number(dayDate)
        const day: string = dayData.day.toUpperCase()
        const selected: boolean = dayIndex === 0

        const items: Array<HomeMealItemInterface> = dayData.meals.map((item: MealInterface, index: number) => {
            const { title, value, notes } = item
            const itemSelected: boolean = index === 0
            return {
                title,
                value,
                notes,
                selected: itemSelected
            }
        })

        const dayItem: HomeDayItemInterface = {
            date,
            realDayISODate,
            day,
            selected,
            items
        }


        return dayItem
    }

    private getEmptyDayItem(realDayISODate: string, dayDate: string, dayName: string, dayIndex: number): HomeDayItemInterface {
        const date: number = Number(dayDate)
        const day: string = dayName.toUpperCase()
        const selected: boolean = dayIndex === 0

        const items: Array<HomeMealItemInterface> = []

        const dayItem: HomeDayItemInterface = {
            date,
            realDayISODate,
            day,
            selected,
            items
        }

        return dayItem
    }

    private get5DayDataFromTimetable(): Array<HomeDayItemInterface> {
        const todayDate: Date = new Date()

        const _5DayData: Array<HomeDayItemInterface> = []

        const flattenedTimetableList: Array<DayInterface> = this.timetablesArray.reduce((acc, val) => acc.concat(val), [])

        let dayIndex: number = -2

        for (let i = 0; i < 5; i++) {
            const dayName: string = moment(todayDate).add(dayIndex, 'days').format('ddd').toLowerCase()
            const dayDate: string = moment(todayDate).add(dayIndex, 'days').format('D')
            const momentCalulcatedDate: string = new Date(moment(todayDate).add(dayIndex, 'days').format('M-D-YYYY')).toISOString()

            const filteredDayInstances: Array<DayInterface> = flattenedTimetableList.filter(dayInfo => dayInfo.day === dayName)

            let isFirstWeek: boolean = true

            let dayItem: HomeDayItemInterface

            if (filteredDayInstances.length > 0) {

                if (this.timetablesArray.length > 3) {
                    // Diff is 3 weeks, so it should take first week
                    // const _2WeekTimetableOriginDate: string = new Date("12-17-2019").toISOString()

                    // Diff is 4 weeks, so it should take second week
                    const _2WeekTimetableOriginDate: string = new Date(this._2WeekCreationDate).toISOString()
                    isFirstWeek = this.getFirstOrSecondWeekStatus(_2WeekTimetableOriginDate, momentCalulcatedDate)
                }

                const weekItemToChoose: number = isFirstWeek ? 0 : 1
                const dayData: DayInterface = filteredDayInstances[weekItemToChoose]

                dayItem = this.getDayItem(momentCalulcatedDate, dayDate, dayData, dayIndex)


            } else { // Meaning it's new, we have no timetable array

                dayItem = this.getEmptyDayItem(momentCalulcatedDate, dayDate, dayName, dayIndex)

            }

            _5DayData.push(dayItem)

            dayIndex++
        }
        return [..._5DayData]
    }

    private set5DayData(): void {
        this._5DayDataArray = this.get5DayDataFromTimetable()
    }

    get5DayData(): Array<HomeDayItemInterface> {
        if (this._5DayDataArray.length === 0)
            this.set5DayData()

        return this._5DayDataArray
    }

    getCurrentTimetable(): Array<Array<DayInterface>> {
        return [...this.timetablesArray]
    }

    getHistoryItems(): Array<HomeHistoryItemInterface> {
        return this.historyItems
    }

    getLoggedInEmail(): string {
        return this.currentlyLoggedInEmail
    }

    getNamedTimetablesArray(): Array<HomeHistoryItemInterface> {
        return [...this.namedTimetablesArray]
    }

    getDayMealItemExactIndices(item: HomeDayItemInterface): DayMealItemExactIndiceInterface {
        let parentIndex = 0
        let childIndex = 0

        for (let i = 0; i < this.timetablesArray.length; i++) {
            const timetableDaysGroup: Array<DayInterface> = this.timetablesArray[i]
            for (let j = 0; j < timetableDaysGroup.length; j++) {
                const timetableDayItem: DayInterface = timetableDaysGroup[j]
                if (item.day!.toLowerCase() === timetableDayItem.day) {
                    parentIndex = i
                    childIndex = j
                    break
                }
            }
        }


        const exactIndex: DayMealItemExactIndiceInterface = {
            parentIndex,
            childIndex,
            hasSecondWeek: false
        }
        return exactIndex
    }

    getDayMeal2WeekItemExactIndices(item: HomeDayItemInterface): DayMealItemExactIndiceInterface {
        let parentIndexArray: Array<number> = []
        let childIndexArray: Array<number> = []

        for (let i = 0; i < this.timetablesArray.length; i++) {
            const timetableDaysGroup: Array<DayInterface> = this.timetablesArray[i]
            for (let j = 0; j < timetableDaysGroup.length; j++) {
                const timetableDayItem: DayInterface = timetableDaysGroup[j]
                if (item.day!.toLowerCase() === timetableDayItem.day) {
                    parentIndexArray.push(i)
                    childIndexArray.push(j)
                }
            }
        }

        const isFirstWeek: boolean = this.getFirstOrSecondWeekStatus(this._2WeekCreationDate, item.realDayISODate as string)

        let parentIndex = isFirstWeek ? parentIndexArray[0] : parentIndexArray[1]
        let childIndex = isFirstWeek ? childIndexArray[0] : childIndexArray[1]

        const exactIndex: DayMealItemExactIndiceInterface = {
            parentIndex,
            childIndex,
            hasSecondWeek: true,
            isFirstWeek,
        }
        return exactIndex
    }

    addHistorySnapshot(change: string): void {
        const frozenTimetables = JSON.parse(JSON.stringify(this.timetablesArray))

        const snapshot: HomeHistoryItemInterface = {
            date: new Date(),
            historyId: uuid(),
            change,
            namedTimetableId: this.currentlyActiveNamedTimetable ? this.currentlyActiveNamedTimetable.namedTimetableId : undefined,
            // timetableName: this.timetableName,
            timetableCreationDate: this._2WeekCreationDate,
            timetablesArrayState: JSON.stringify(frozenTimetables)
        }

        if (this.historyItems.length > 20)
            this.historyItems.pop()

        this.historyItems.unshift(snapshot)

        this.serializedAndStoreState()
    }

    private unloadHistoryItem(foundSnapshot: HomeHistoryItemInterface): void {
        // this.timetableName = foundSnapshot.timetableName
        this._2WeekCreationDate = foundSnapshot.timetableCreationDate as string
        this.timetablesArray = JSON.parse(foundSnapshot.timetablesArrayState as string)
    }

    restoreHistorySnapshot(snapshot: HomeHistoryItemInterface): void {
        const foundSnapshot = this.historyItems.find((historyItem: HomeHistoryItemInterface) => historyItem.historyId === snapshot.historyId)

        this.unloadHistoryItem(foundSnapshot as HomeHistoryItemInterface)
        this.set5DayData()

        const pastDay = moment(foundSnapshot!.date)
        const currentDay = moment(new Date())
        const numberOfDaysDifference = currentDay.diff(pastDay, 'days')

        const humanizedTime = numberOfDaysDifference > 3 ?
            moment(foundSnapshot!.date, 'DD-MM-YYYY').format("Do MMM YYYY") :
            moment(new Date(foundSnapshot!.date)).fromNow()

        const statement: string = `Restored timetable from ${humanizedTime}`

        this.addHistorySnapshot(statement)

    }


    private addHistorySnapshotForHomepageUpdates(
        originalItem: HomeDayItemInterface,
        update: PolyDialogTypeInterface,
        parentIndex: number,
        childIndex: number,
        isFirstWeek: boolean,
        hasSecondWeek: boolean,
        isNotes: boolean,
    ): void {
        const day: string = moment(originalItem.realDayISODate).format('dddd')
        const mealChanged: string = this.timetablesArray[parentIndex][childIndex].meals[update.timetableItemIndex as number].title as string
        const weekNumber: string = hasSecondWeek ? (isFirstWeek ? ' first week' : ' second week') : ''
        const fullStatement: string = `Changed ${mealChanged}${isNotes ? ' notes' : ''} for${weekNumber} ${day}s`

        this.addHistorySnapshot(fullStatement)
    }

    updateDayItemUpdateFromHomepage(originalItem: HomeDayItemInterface, update: PolyDialogTypeInterface): void {
        const timetableHasOneWeek: boolean = this.timetablesArray.length === 3

        const { parentIndex, childIndex, isFirstWeek, hasSecondWeek } = timetableHasOneWeek ?
            this.getDayMealItemExactIndices(originalItem) :
            this.getDayMeal2WeekItemExactIndices(originalItem)

        // STORE HISTORY STATE HERE!!!!
        // Changed lunch for first week mondays

        // const day: string = moment(originalItem.realDayISODate).format('dddd')
        // const mealChanged: string = this.timetablesArray[parentIndex][childIndex].meals[update.timetableItemIndex].title
        // const weekNumber: string = hasSecondWeek ? (isFirstWeek ? ' first week' : ' second week') : ''
        // const fullStatement: string = `Changed ${mealChanged} for${weekNumber} ${day}s`

        // this.addHistorySnapshot(fullStatement)
        this.timetablesArray[parentIndex][childIndex].meals[update.timetableItemIndex as number].value = update.updateValue
        this.set5DayData()

        const isNotes = false

        this.addHistorySnapshotForHomepageUpdates(
            originalItem,
            update,
            parentIndex,
            childIndex,
            isFirstWeek as boolean,
            hasSecondWeek as boolean,
            isNotes
        )

    }

    updateDayItemNotesUpdateFromHomepage(originalItem: HomeDayItemInterface, update: PolyDialogTypeInterface): void {
        const timetableHasOneWeek: boolean = this.timetablesArray.length === 3

        const { parentIndex, childIndex, isFirstWeek, hasSecondWeek } = timetableHasOneWeek ?
            this.getDayMealItemExactIndices(originalItem) :
            this.getDayMeal2WeekItemExactIndices(originalItem)

        // STORE HISTORY STATE HERE!!!!
        // Changed lunch notes for second week tuesdays

        this.timetablesArray[parentIndex][childIndex].meals[update.timetableItemIndex as number].notes = update.updateValue
        this.set5DayData()

        const isNotes = true

        this.addHistorySnapshotForHomepageUpdates(
            originalItem,
            update,
            parentIndex,
            childIndex,
            isFirstWeek as boolean,
            hasSecondWeek as boolean,
            isNotes
        )
    }

    updateTimetableArrayFromMyTimetablesPage(updatedTimetableArray: Array<Array<DayInterface>>, update: string): void {

        this._2WeekCreationDate = updatedTimetableArray.length > 3 ?
            new Date().toISOString() : ''

        this.timetablesArray = updatedTimetableArray
        this.set5DayData()

        this.addHistorySnapshot(update)
    }

    // Storage ops
    deleteHistoryItem(index: number): void {
        this.historyItems.splice(index, 1)
        this.serializedAndStoreState()
    }

    randomiseWholeTimetableFromHomepage(): void {
        const flattenedLists: FlattenedLists = this.getFlattenedTimetableArrayList(this.timetablesArray)
        const randomisedLists: RandomisedListsInterface<MealInterface> = this.getRandomisedLists(flattenedLists)
        const indexedItems: Array<RandomisedObjectInterface> = this.getIndexedRandomisedList(randomisedLists)

        this.timetablesArray = this.updateAndGetTimeTableArrayWithIndexedList(indexedItems, this.timetablesArray)

        this.addHistorySnapshot('Changed timetable order')

        this.set5DayData()
    }

    changeExistingTimetableName(timetable: HomeHistoryItemInterface, newTimetableName: string): void {
        const foundExistingTimetableIndex: number = this.namedTimetablesArray
            .findIndex((searchedTimetable: HomeHistoryItemInterface) => searchedTimetable.namedTimetableId === timetable.namedTimetableId)

        this.namedTimetablesArray[foundExistingTimetableIndex].timetableName = newTimetableName

        this.addHistorySnapshot(`Changed timetable name from '${timetable.timetableName}' to '${newTimetableName}'`)
    }

    shiftTimetablePriorityUsingName(timetableNameSelected: string): void {
        const foundTimetable: HomeHistoryItemInterface = this.namedTimetablesArray
            .find((searchedTimetable: HomeHistoryItemInterface) => searchedTimetable.timetableName === timetableNameSelected) as HomeHistoryItemInterface

        if (!foundTimetable)
            return

        this.namedTimetablesArray = this.namedTimetablesArray
            .filter((searchedTimetable: HomeHistoryItemInterface) => searchedTimetable.namedTimetableId !== foundTimetable.namedTimetableId)

        this.namedTimetablesArray.unshift(foundTimetable)
        this.currentlyActiveNamedTimetable = foundTimetable

        this.unloadHistoryItem(foundTimetable)
        this.addHistorySnapshot(`Selected ${foundTimetable.timetableName}`)
        this.set5DayData()
    }

    setAllPreviousHistoryItemsTimetableIdToTimetableId(timetableId: string): void {

        this.historyItems = this.historyItems.map(historyItem => {
            historyItem.namedTimetableId = timetableId
            return historyItem
        })

    }

    addANewTimetable(timetableName: string): void {

        const foundExistingTimetable: HomeHistoryItemInterface =
            this.namedTimetablesArray.find((timetable: HomeHistoryItemInterface) => timetable.timetablesArrayState === JSON.stringify(this.timetablesArray)) as HomeHistoryItemInterface

        if (foundExistingTimetable)
            throw new Error(`Configuration already exists in ${foundExistingTimetable.timetableName}`)

        const frozenTimetables = JSON.parse(JSON.stringify(this.timetablesArray))

        this._2WeekCreationDate = this.timetablesArray.length > 3 ? new Date().toISOString() : ''

        const namedTimetableId: string = uuid()

        const newTimetable: HomeHistoryItemInterface = {
            date: new Date(),
            historyId: uuid(),
            namedTimetableId,
            change: `Added a new timetable '${timetableName}'`,
            timetableName,
            timetableCreationDate: this._2WeekCreationDate,
            timetablesArrayState: JSON.stringify(frozenTimetables)
        }

        if (!this.currentlyActiveNamedTimetable)
            this.setAllPreviousHistoryItemsTimetableIdToTimetableId(namedTimetableId)

        if (this.historyItems.length > 20)
            this.historyItems.pop()

        this.namedTimetablesArray.unshift(newTimetable)
        this.historyItems.unshift(newTimetable)
        this.currentlyActiveNamedTimetable = newTimetable
    }

    deleteANamedTimetable(timetable: HomeHistoryItemInterface): void {
        this.historyItems = this.historyItems
            .filter((historyItem: HomeHistoryItemInterface) => historyItem.namedTimetableId !== timetable.namedTimetableId)

        this.namedTimetablesArray = this.namedTimetablesArray
            .filter((_timetable: HomeHistoryItemInterface) => _timetable.namedTimetableId !== timetable.namedTimetableId)

        this.currentlyActiveNamedTimetable = undefined

        this.addHistorySnapshot(`Deleted ${timetable.timetableName}`)
    }

    randomiseTimetable(): void {
        // const flattenedLists: FlattenedLists = this.getFlattenedTimetableArrayList()
        // const randomisedLists: RandomisedListsInterface<MealInterface> = this.getRandomisedLists(flattenedLists)
        // const indexedItems: Array<RandomisedObjectInterface> = this.getIndexedRandomisedList(randomisedLists)

        // this.updateAndGetTimeTableArrayWithIndexedList(indexedItems)
    }

    // Flatten the lists into an array of breakfast, lunch and supper
    getFlattenedTimetableArrayList(timetablesArray: Array<Array<DayInterface>>): FlattenedLists {
        const breakfastArray: Array<MealInterface> = []
        const lunchArray: Array<MealInterface> = []
        const supperArray: Array<MealInterface> = []

        for (let i = 0; i < timetablesArray.length; i++) {
            const daysTimetableList = timetablesArray[i]

            for (let j = 0; j < daysTimetableList.length; j++) {
                const dayMeals = daysTimetableList[j].meals

                const breakfastItem = dayMeals.find(meal => meal.title === 'breakfast')
                const lunchItem = dayMeals.find(meal => meal.title === 'lunch')
                const supperItem = dayMeals.find(meal => meal.title === 'supper')

                breakfastArray.push(breakfastItem as MealInterface)
                lunchArray.push(lunchItem as MealInterface)
                supperArray.push(supperItem as MealInterface)
            }
        }

        return {
            breakfastArray,
            lunchArray,
            supperArray
        }
    }


    getRandomisedLists(
        lists: FlattenedLists
    ): RandomisedListsInterface<MealInterface> {
        const breakfastArray: Array<MealInterface> = lists.breakfastArray
        const lunchArray: Array<MealInterface> = lists.lunchArray
        const supperArray: Array<MealInterface> = lists.supperArray

        const randomisedTimetableLists = new Randomise<MealInterface>(breakfastArray, lunchArray, supperArray)
        const randomisedLists: RandomisedListsInterface<MealInterface> = randomisedTimetableLists.getRandomisedMealLists()

        return randomisedLists
    }


    getIndexedRandomisedList(randomisedLists: RandomisedListsInterface<MealInterface>): Array<RandomisedObjectInterface> {
        const randomisedBreakfast: Array<MealInterface> = randomisedLists.breakfast
        const randomisedLunch: Array<MealInterface> = randomisedLists.lunch
        const randomisedSupper: Array<MealInterface> = randomisedLists.supper

        let parentIndex = 0
        let dayIndex = -1
        let itemIndex = 0

        const indexedList: Array<RandomisedObjectInterface> = randomisedBreakfast.map((item: MealInterface, index: number) => {

            if (dayIndex === 2 || parentIndex === 2 || parentIndex === 5) {
                dayIndex = 0
                parentIndex++
            }
            else {
                dayIndex++
            }

            return {
                parentIndex,
                dayIndex,
                itemIndex,
                breakfastItem: item,
                lunchItem: randomisedLunch[index],
                supperItem: randomisedSupper[index]
            }

        })

        return indexedList
    }


    updateAndGetTimeTableArrayWithIndexedList(indexedItems: Array<RandomisedObjectInterface>, timetablesArray: Array<Array<DayInterface>>): Array<Array<DayInterface>> {
        while (indexedItems.length > 0) {
            const indexedItem = indexedItems.pop()

            timetablesArray[indexedItem!.parentIndex as number]
            [indexedItem!.dayIndex as number].meals[0] = indexedItem!.breakfastItem as MealInterface

            timetablesArray[indexedItem!.parentIndex as number]
            [indexedItem!.dayIndex as number].meals[1] = indexedItem!.lunchItem as MealInterface

            timetablesArray[indexedItem!.parentIndex as number]
            [indexedItem!.dayIndex as number].meals[2] = indexedItem!.supperItem as MealInterface

        }

        return timetablesArray
    }

    // Storage ops
    clearMyHistory(): void {
        // Make api call if there's internet
        this.historyItems = []

        this.serializedAndStoreState()
    }

    clearAllServiceData(): void {
        this._2WeekCreationDate = ''
        this.currentlyActiveNamedTimetable = undefined

        this.timetablesArray = []
        this._5DayDataArray = []
        this.historyItems = []
        this.namedTimetablesArray = []

        this.set5DayData()
    }

    // Storage ops
    clearAllMyData(): void {
        // Make api call if there's internet
        this.clearAllServiceData()

        this.serializedAndStoreState()
    }


    // Storage ops
    logoutUser(): void {
        this.currentlyLoggedInEmail = ''

        this.serializedAndStoreState()
    }


    // Storage Operations
    async serializedAndStoreState(): Promise<void> {

        try {

            const state: StateObjectInterface = {
                _2WeekCreationDate: this._2WeekCreationDate,
                timetablesArray: this.timetablesArray,
                historyItems: this.historyItems,
                namedTimetablesArray: this.namedTimetablesArray,
                currentlyActiveNamedTimetable: this.currentlyActiveNamedTimetable as HomeHistoryItemInterface,
                currentlyLoggedInEmail: this.currentlyLoggedInEmail
            }

            const serializedState = JSON.stringify(state)
            this.storage.set(this.storageKey, serializedState)

        } catch (e) {
            throw (e)
        }

    }

    async deserializeAndUnwrapState(): Promise<void> {
        try {

            const serializedState = await this.storage.get(this.storageKey)

            const token = await this.storage.get('token')
            this.token = token

            if (!serializedState)
                return

            const state: StateObjectInterface = JSON.parse(serializedState)

            this._2WeekCreationDate = state._2WeekCreationDate
            this.timetablesArray = state.timetablesArray
            this.historyItems = state.historyItems
            this.namedTimetablesArray = state.namedTimetablesArray
            this.currentlyActiveNamedTimetable = state.currentlyActiveNamedTimetable
            this.currentlyLoggedInEmail = state.currentlyLoggedInEmail

            this.set5DayData()

            if (this.timetablesArray.length > 0 && this.historyItems.length === 0)
                this.addHistorySnapshot('Getting started')

        } catch (e) {
            throw (e)
        }
    }

    // Server operations
    private async getToken(): Promise<string> {
        const token = this.storage.get('token')
        return token
    }

    private async setToken(token: string): Promise<void> {
        await this.storage.set('token', token)
    }

    private setServiceToken(token: string): void {
        this.token = token
    }

    async loginSignupUser(email: string, password: string, isLogin: boolean): Promise<void> {
        try {
            if (!navigator.onLine)
                throw ({ response: { data: { message: 'Please switch on your internet' } } })

            // Login or signup
            const response = await axios({
                url: this.serverUrl + '/users',
                method: isLogin ? 'POST' : 'PUT',
                data: { email, password }
            })

            this.currentlyLoggedInEmail = email
            this.serializedAndStoreState()

            // Get token and store it, make it current active token
            const token = response.data.token
            this.setToken(token)
            this.setServiceToken(token)

        } catch (e) {
            throw ({ message: e.response.data })
        }
    }

    async uploadMyState(): Promise<void> {
        try {
            if (!navigator.onLine)
                throw ({ response: { data: { message: 'Please switch on your internet' } } })

            // Get state from storage and make request
            const serializedState = await this.storage.get(this.storageKey)

            const fetchedState: StateObjectInterface = JSON.parse(serializedState)

            const nothingToStore = fetchedState.historyItems.length === 0 && fetchedState.timetablesArray.length === 0 && fetchedState.namedTimetablesArray.length === 0

            if (nothingToStore)
                throw ({ response: { data: 'You currently have no data to store online' } })

            const state = {
                _2WeekCreationDate: JSON.stringify(fetchedState._2WeekCreationDate),
                timetablesArray: JSON.stringify(fetchedState.timetablesArray),
                historyItems: JSON.stringify(fetchedState.historyItems),
                namedTimetablesArray: JSON.stringify(fetchedState.namedTimetablesArray),
                currentlyActiveNamedTimetable: JSON.stringify(fetchedState.currentlyActiveNamedTimetable)
            }

            const response = await axios({
                url: this.serverUrl + `/users/state/${this.token}`,
                method: 'POST',
                data: { state }
            })

            // Get token and store it, make it current active token
            const token = response.data.token
            this.setToken(token)
            this.setServiceToken(token)

        } catch (e) {
            throw ({ message: e.response.data })
        }
    }

    async getMyState(): Promise<void> {
        try {
            if (!navigator.onLine)
                throw ({ response: { data: { message: 'Please switch on your internet' } } })

            // Get state from online
            const response = await axios({
                url: this.serverUrl + `/users/state/${this.token}`,
                method: 'GET'
            })

            const { token, state } = response.data

            if (Object.keys(state).length === 0)
                throw ({ response: { data: 'You currently have no data stored online' } })

            // Store state in storage
            const deserializedState = {
                _2WeekCreationDate: JSON.parse(state._2WeekCreationDate),
                timetablesArray: JSON.parse(state.timetablesArray),
                historyItems: JSON.parse(state.historyItems),
                namedTimetablesArray: JSON.parse(state.namedTimetablesArray),
                currentlyActiveNamedTimetable: JSON.parse(state.currentlyActiveNamedTimetable),
                currentlyLoggedInEmail: this.currentlyLoggedInEmail
            }

            const serializedState = JSON.stringify(deserializedState)
            this.storage.set(this.storageKey, serializedState)

            // Unwrap state in data service
            this._2WeekCreationDate = deserializedState._2WeekCreationDate
            this.timetablesArray = deserializedState.timetablesArray
            this.historyItems = deserializedState.historyItems
            this.namedTimetablesArray = deserializedState.namedTimetablesArray
            this.currentlyActiveNamedTimetable = deserializedState.currentlyActiveNamedTimetable

            // Do initialization again
            this.set5DayData()

            if (this.timetablesArray.length > 0 && this.historyItems.length === 0)
                this.addHistorySnapshot('Getting started')

            // Get token and store it, make it current active token
            this.setToken(token)
            this.setServiceToken(token)

        } catch (e) {
            throw ({ message: e.response ? e.response.data : "Couldn't fetch your data" })
        }
    }

    async apiDeleteMyAccount(): Promise<void> {
        try {
            if (!navigator.onLine)
                throw ({ response: { data: { message: 'Please switch on your internet' } } })

            await axios({
                url: this.serverUrl + `/users/${this.token}`,
                method: 'DELETE'
            })

        } catch (e) {
            throw ({ message: e.response.data })
        }
    }

    private checkInternetConnection(): void {
        if (!navigator.onLine)
            throw ({ message: 'Please switch on your internet first' })
    }

    async forgotMyPassword(email: string): Promise<void> {
        try {
            this.checkInternetConnection()

            // send email to prs server
            const platform = "foorize"

            await axios({
                url: 'https://prs-server.herokuapp.com/resetpassword',
                method: 'GET',
                params: {
                    email,
                    platform
                }
            })

        } catch (e) {
            throw ('Please try again later')
        }
    }


}

const appStorage = new AppStorage()

export default new DataProvider(appStorage)